// The browser's extensions button: a puzzle piece, as Chrome draws it in the toolbar.
export const PuzzleIcon = ({ size }: { size: number }) => (
  <svg aria-hidden="true" fill="none" height={size} viewBox="0 0 24 24" width={size}>
    <path
      d="M10 3.5a1.6 1.6 0 013.2 0c0 .5.4.9.9.9H16a1.4 1.4 0 011.4 1.4v1.9c0 .5.4.9.9.9a1.6 1.6 0 010 3.2c-.5 0-.9.4-.9.9v2A1.4 1.4 0 0116 17.1h-2c-.5 0-.9-.4-.9-.9a1.6 1.6 0 00-3.2 0c0 .5-.4.9-.9.9H7A1.4 1.4 0 015.6 15.7v-2c0-.5-.4-.9-.9-.9a1.6 1.6 0 010-3.2c.5 0 .9-.4.9-.9V6.8A1.4 1.4 0 017 5.4h2c.5 0 .9-.4.9-.9z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
